<template lang="pug">
  y-dialog(v-model="showDialog" :fullscreen="$vuetify.breakpoint.xsOnly" max-width="600" persistent scrollable content-class="round-3xl")
    v-card
      v-card-title.pa-4
        v-row(no-gutters align="center")
          v-col(cols="10" offset="1")
            div.text-xl.font-bold.neutral700--text.text-center {{ $t('new_donation') }}
          v-col(cols="1" align="right")
            v-btn.ml-n3(text icon @click="closeDialog")
              v-icon(color="neutral700" :size="24") mdi-close
      v-divider
      v-card-text(:class="$vuetify.breakpoint.xsOnly ? 'pa-4' : 'pa-8'")
        v-form(ref="form")
          div.text-md.font-semibold.neutral700--text {{ $t('fill_the_information_below') }}

          div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('donation_amount_date_created') }}
          v-row(v-for="(transaction, tidx) in transactions" no-gutters :key="'trxn-'+tidx" align="center")
            v-col.pr-2.pt-3
              yc-text-field(label="Amount" v-model="transaction.amount" placeholder="Enter amount" :prefix="$currency.symbol" type="number" hide-details="true" :rules="rules.not_empty")
            v-col.pl-2.pt-3
              y-dialog(v-model='transaction.showPicker' width='320px')
                template(v-slot:activator='{ on }')
                  yc-text-field.text-md.font-normal.round-xl(:value="transaction.record_date ? $options.filters.humanizeDate(transaction.record_date) : null" :label="$t('date')" outlined hide-details="true" :rules="rules.not_empty" readonly :calendar="true" :on='on')
                v-card
                  v-card-text.px-2.pt-2.pb-0
                    yc-date-picker(:parentDate.sync="transaction.record_date" color="info")
                  v-card-actions.px-4.pb-4
                    v-btn.round-lg.heading-6(color="info500" block dark depressed :dark="Boolean(transaction.record_date)" :disabled="!transaction.record_date" @click="transaction.showPicker = false") {{ $t('select') }}
            v-col.shrink.pl-4.pt-3(v-if="transactions.length > 1")
              v-btn(icon small @click="removeItem(tidx)")
                v-icon(color="neutral700") $yzi-trash-03

          v-btn.button-sm.mt-4(color="neutral700" outlined @click="transactions.push({})")
            v-icon(left size="20") mdi-plus
            | {{ $t('add_more_donation') }}

      v-divider
      v-card-actions.py-4(:class="$vuetify.breakpoint.xsOnly ? 'px-4' : 'px-8'")
        v-btn.button-md.neutral700--text.px-0(@click="closeDialog" text) {{ $t('cancel') }}
        v-spacer
        v-btn.button-md(:loading="isLoading" color="neutral700" depressed dark @click="saveData") {{ $t('save') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AddNewTransaction',
  components: {},
  props: ['open'],
  data () {
    return {
      isFetching: false,
      isLoading: false,
      transactions: [{}],
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      campaign: 'donation/getCampaign'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    saveData () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      const data = { campaign: this.campaign.id, donations: this.transactions.map(m => { return { amount: m.amount * this.$currency.multiplier, record_date: m.record_date }}) }
      this.$axios.post(`/donations/${this.company.slug}/transactions/`, data)
        .then(() => {
          this.$emit('reset')
          this.showDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    },
    removeItem (idx) {
      this.transactions.splice(idx, 1)
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>